import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Expander from 'components/common/Expander'
import MainSpecs from './MainSpecs'

const AdditionalSpecs = ({ specs = []}) =>
  <Expander
    expandedTitle="Hide Additional Specs"
    title="View Additional Specs"
    above
    right >
    <MainSpecsSecondary specs={ specs } />
  </Expander>

export default AdditionalSpecs

AdditionalSpecs.propTypes = {
  specs: PropTypes.arrayOf(PropTypes.object)
}

const MainSpecsSecondary = styled(MainSpecs)`
  border-top: none;
`
